import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAbortion = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 5C8.13401 5 5 8.13401 5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C11.4477 21 11 20.5523 11 20C11 19.4477 11.4477 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.29289 20.7071C3.68342 21.0976 4.31658 21.0976 4.70711 20.7071L6 19.4142L7.29289 20.7071C7.68342 21.0976 8.31658 21.0976 8.70711 20.7071C9.09763 20.3166 9.09763 19.6834 8.70711 19.2929L7.41421 18L8.70711 16.7071C9.09763 16.3166 9.09763 15.6834 8.70711 15.2929C8.31658 14.9024 7.68342 14.9024 7.29289 15.2929L6 16.5858L4.70711 15.2929C4.31658 14.9024 3.68342 14.9024 3.29289 15.2929C2.90237 15.6834 2.90237 16.3166 3.29289 16.7071L4.58579 18L3.29289 19.2929C2.90237 19.6834 2.90237 20.3166 3.29289 20.7071Z",
			fill: "currentColor"
		})
	]
});
export default SvgAbortion;
